<template>
    <v-layout wrap>
        <v-navigation-drawer absolute permanent right style="width: 600px;">
            <!--  상단 이미지 및 선택 타이틀 이름-->
            <v-list class="pa-1">
                <v-list-item>
                    <v-tabs v-if="copyValue._instanceInfo">
                        <v-tab v-if="copyValue._instanceInfo">
                            <v-list-item-title>Instance Info</v-list-item-title>
                        </v-tab>
                    </v-tabs>
                    <v-tabs v-model="tab">
                        <v-tab v-for="tab in tabs" :key="tab" :id="tab.toLowerCase() + _uid">
                            <v-list-item-title>{{ tab }}</v-list-item-title>
                        </v-tab>
                    </v-tabs>
                    
                    <v-btn icon @click.native="closePanel()">
                        <v-icon color="grey lighten-1">mdi-close</v-icon>
                    </v-btn>
                </v-list-item>
            </v-list>

            <v-simple-table  v-if="copyValue._instanceInfo">
                <template v-slot:default>
                    <thead>
                        <tr>
                            <th class="text-left">Key</th>
                            <th class="text-left">Value</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(row, index) in copyValue._instanceInfo" :key="index">
                            <td>{{ index }}</td>
                            <td>{{ copyValue._instanceInfo[index] }}</td>
                        </tr>
                    </tbody>
                </template>
            </v-simple-table>

            <v-list class="pt-0" dense flat>
                <v-divider></v-divider>
                <div v-if="tab == 0" style="margin-top: 10px">
                    <v-card flat>
                        <v-card-text>
                            <v-text-field
                                    v-if="tracingTag !== null"
                                    v-model="tracingTag"
                                    label="액티비티 ID*"
                                    counter="50"
                            ></v-text-field>
                            
                            <v-text-field
                                    v-model="namePanel"
                                    label="액티비티 명"
                                    autofocus
                            ></v-text-field>
                            
                            <!-- v-if="copyValue._type == 'org.uengine.kernel.bpmn.CallActivity'" start -->
                            <div v-if="copyValue._type == 'org.uengine.kernel.bpmn.CallActivity'">
                                <v-autocomplete
                                        v-model="copyValue.definitionId"
                                        :items="recommendedDefinitionList"
                                        :filter="fetchDefinitionList"
                                        label="연결 프로세스 정의"
                                ></v-autocomplete>

                                <div v-if="copyValue.definitionId">
                                    <label>연결 변수 매핑</label>
                                    <bpmn-parameter-contexts
                                            :parameter-contexts="copyValue.variableBindings"
                                            :definition="definition"
                                            :callee-definition-id="copyValue.definitionId"
                                            :for-sub-process="true"
                                            :for-call-activity="true"
                                    ></bpmn-parameter-contexts>

                                    <label>연결 역할 매핑</label>
                                    <bpmn-role-parameter-contexts
                                            :parameter-contexts="copyValue.roleBindings"
                                            :callee-definition-id="copyValue.definitionId"
                                            :definition="definition">
                                    </bpmn-role-parameter-contexts>
                                </div>
                            </div>
                            <!-- v-if="copyValue._type == 'org.uengine.kernel.bpmn.CallActivity'" end -->

                            <!-- v-if="copyValue._type == 'org.uengine.kernel.ScriptActivity'" start -->
                            <div v-if="copyValue._type == 'org.uengine.kernel.ScriptActivity'">
                                <v-select
                                        v-model="copyValue.language"
                                        :items="langList"
                                        item-value="langList.index"
                                        label="실행 언어"
                                ></v-select>
                                <v-textarea
                                        v-model="copyValue.script"
                                        label="스크립트"
                                        dense
                                ></v-textarea>
                                <v-textarea
                                        v-model="copyValue.out.name"
                                        label="실행 결과 변수 매핑"
                                        dense
                                ></v-textarea>
                            </div>
                            <!-- v-if="copyValue._type == 'org.uengine.kernel.ScriptActivity'" end -->

                            <!-- v-if="copyValue._type == 'org.uengine.kernel.bpmn.SendTask'" start -->
                            <div v-if="copyValue._type == 'org.uengine.kernel.bpmn.SendTask'">
                                <v-text-field
                                        v-model="copyValue.inputPayloadTemplate"
                                        label="입력 데이터 (JSON/XML)"
                                ></v-text-field>
                                <v-text-field
                                        v-model="copyValue.dataInput.name"
                                        label="결과 입력 변수"
                                ></v-text-field>
                            </div>
                            <!-- v-if="copyValue._type == 'org.uengine.kernel.bpmn.SendTask'" end -->

                            <!-- v-if="copyValue._type == 'org.uengine.kernel.HumanActivity'" start -->
                            <div v-if="copyValue._type == 'org.uengine.kernel.HumanActivity'">
                                <v-text-field
                                        v-model="copyValue.role.name"
                                        label="역할" readonly
                                ></v-text-field>
                                <label>파라미터</label>
                                <bpmn-parameter-contexts
                                    :parameter-contexts="copyValue.parameters"
                                    :definition="definition"
                                    :multi="true"
                                ></bpmn-parameter-contexts>
                            </div>
                            <!-- v-if="copyValue._type == 'org.uengine.kernel.HumanActivity'" end -->

                            <!-- v-if="copyValue._type == 'org.uengine.kernel.bpmn.ServiceTask'" start -->
                            <div v-if="copyValue._type == 'org.uengine.kernel.bpmn.ServiceTask'">
                                <v-text-field
                                        v-model="copyValue.role.name"
                                        label="역할 (추후 레인에서 자동설정)" readonly
                                ></v-text-field>
                                <v-text-field
                                        v-model="copyValue.uriTemplate"
                                        label="호출 URI 패턴"
                                ></v-text-field>
                                <v-checkbox
                                        v-if="copyValue.uriTemplate && copyValue.uriTemplate.indexOf('https://') == 0" 
                                        v-model="copyValue.noValidationForSSL"
                                        label="Don't validate the certificate"
                                ></v-checkbox>
                                <v-select
                                        v-if="links"
                                        v-model="copyValue.uriTemplate"
                                        :items="links"
                                        item-text="link.link"
                                        item-value="link.href"
                                        @change="giveJSONHint"
                                        label="호출 서비스 선택"
                                ></v-select>
                                <v-select
                                        v-model="copyValue.method"
                                        :items="methodList"
                                        label="호출 메서드"
                                ></v-select>
                                <v-textarea
                                        v-if="'GET,DELETE'.indexOf(copyValue.method) == -1"
                                        v-model="copyValue.inputPayloadTemplate"
                                        label="입력 데이터 (JSON template)"
                                        dense
                                ></v-textarea>
                                <label>결과 데이터 매핑</label>
                                <bpmn-parameter-contexts
                                        :parameter-contexts="copyValue.outputMapping"
                                        :definition="definition"
                                ></bpmn-parameter-contexts>
                                <v-checkbox
                                        v-model="copyValue.skipIfNotFound"
                                        label="리소스 없을 경우 (404) 오류 처리 하지 않음"
                                ></v-checkbox>
                            </div>
                            <!-- v-if="copyValue._type == 'org.uengine.kernel.bpmn.ServiceTask'" end -->

                            <!-- v-if="copyValue._type == 'org.uengine.kernel.bpmn.ReceiveTask'" start -->
                            <div v-if="copyValue._type == 'org.uengine.kernel.bpmn.ReceiveTask'">
                                <v-text-field
                                        v-model="copyValue.role.name"
                                        label="역할 (추후 레인에서 자동설정)" readonly
                                ></v-text-field>
                                <v-text-field
                                        v-model="copyValue.uriTemplate"
                                        label="호출 URI 패턴"
                                ></v-text-field>
                                <v-checkbox
                                        v-if="copyValue.uriTemplate && copyValue.uriTemplate.indexOf('https://') == 0" 
                                        v-model="copyValue.noValidationForSSL"
                                        label="Don't validate the certificate"
                                ></v-checkbox>
                                <v-select
                                        v-if="links"
                                        v-model="copyValue.uriTemplate"
                                        :items="links"
                                        item-text="link.link"
                                        item-value="link.href"
                                        @change="giveJSONHint"
                                        label="호출 서비스 선택"
                                ></v-select>
                                <v-select
                                        v-model="copyValue.method"
                                        :items="methodList"
                                        label="호출 메서드"
                                ></v-select>
                                <v-textarea
                                        v-if="'GET,DELETE'.indexOf(copyValue.method) == -1"
                                        v-model="copyValue.inputPayloadTemplate"
                                        label="입력 데이터 (JSON template)"
                                        dense
                                ></v-textarea>
                                <label>결과 데이터 매핑</label>
                                <bpmn-parameter-contexts
                                        :parameter-contexts="copyValue.outputMapping"
                                        :definition="definition"
                                ></bpmn-parameter-contexts>
                                <v-checkbox
                                        v-model="copyValue.skipIfNotFound"
                                        label="리소스 없을 경우 (404) 오류 처리 하지 않음"
                                ></v-checkbox>
                            </div>
                            <!-- v-if="copyValue._type == 'org.uengine.kernel.bpmn.ReceiveTask'" end -->

                            <v-text-field
                                    v-if="copyValue._type != 'org.uengine.kernel.ScriptActivity'"
                                    v-model="copyValue.retryDelay"
                                    label="retryDelay"
                                    type="number"
                            ></v-text-field>
                        </v-card-text>
                    </v-card>
                </div>
                <div v-if="tab == 1">
                    <v-card flat>
                        <v-card-text>
                            <v-row>
                                <v-col cols="6" class="py-0">
                                    <v-text-field
                                            label="x"
                                            v-model="x"
                                            type="number"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="6" class="py-0">
                                    <v-text-field
                                            label="y"
                                            v-model="y"
                                            type="number"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="6" class="py-0">
                                    <v-text-field
                                            label="width"
                                            v-model="width"
                                            type="number"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="6" class="py-0">
                                    <v-text-field
                                            label="height"
                                            v-model="height"
                                            type="number"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-text-field
                                    v-for="(item, idx) in style" :key="idx"
                                    v-model="style[idx].value"
                                    :label="item.key"
                            ></v-text-field>
                        </v-card-text>
                    </v-card>
                </div>
            </v-list>

        </v-navigation-drawer>
    </v-layout>
</template>

<script>
    import BpmnPropertyPanel from '../BpmnPropertyPanel'

    export default {
        mixins: [BpmnPropertyPanel],
        name: 'bpmn-task-panel',
        props: {
            linkList: Array,
        },
        data() {
            return {
                tabs: [ 'Properties', 'Visual' ],
                tab: null,
                langList: [ 'Javascript', 'Java' ],
                links: this.linkList,
                methodList: [ 'GET', 'POST', 'DELETE', 'PUT', 'PATCH' ],
            }
        },
        created: function () {
        },
        mounted: function () {
        },
        computed: {},
        watch: {},
        methods: {
            fetchDefinitionList() {
                this.$emit('fetchDefinitionList');
            },
            giveJSONHint() {
                this.$emit('giveJSONHint');
            }
        }
    }
</script>


<style lang="scss" rel="stylesheet/scss">

</style>

